<template>
	<div class="result-group">
		<div class="group-header">{{ isShowingDefaults ? 'Recent ' : '' }}{{ groupTitle }}</div>
		<SpotlightSearchResult
			v-for="(result, index) in resultsToShow"
			:key="result.id || index"
			:ref="`${isShowingDefaults ? 'default' : 'result'}-${groupType}-${index}`"
			:data-id="result.id"
			:data-group="groupType"
			:image="result.imageUrl"
			:icon="result.icon"
			:action-icons="result.actionIcons"
			:action-label="result.actionLabel"
			:title="result.title"
			:description="result.description"
			:meta="result.meta"
			@select="$emit('select', result)"
		/>
		<div
			v-if="moreResultsAvailable > 0"
			class="show-more-button"
			@click="showResults += 10"
		>
			Show more
		</div>
	</div>
</template>

<script lang="ts">
import moment from 'moment'
import Vue, { PropType } from 'vue'
import SpotlightSearchResult from '@cv/components/molecules/SpotlightSearchResult.vue'
import { ScoredSpotlightResult, SearchResultGroupName } from '@cv/store/spotlight-search'

export default Vue.extend({
	name: 'SpotlightSearchGroup',
	components: {
		SpotlightSearchResult
	},
	props: {
		groupType: {
			type: String as PropType<SearchResultGroupName>,
			required: true
		},
		results: {
			type: Array as PropType<ScoredSpotlightResult[]>,
			required: true
		},
		isShowingDefaults: {
			type: Boolean,
			default: false
		},
		activeGroup: {
			type: String as PropType<SearchResultGroupName | null>,
			default: null
		},
		activeIndex: {
			type: Number,
			default: -1
		}
	},
	data() {
		return {
			showResultsDefault: 4,
			showResults: 4
		}
	},
	computed: {
		groupTitle() {
			return this.$store.getters['spotlightSearch/getGroupTitle'](this.groupType)
		},
		resultsToShow() {
			return this.results.slice(0, this.showResults)
		},
		moreResultsAvailable(): number {
			return Math.max(0, this.results.length - this.showResults)
		}
	},
	watch: {
		results() {
			this.showResults = this.showResultsDefault
		}
	},
	methods: {
		moment(string) {
			return moment(string)
		},
		isActiveResult(index: number): boolean {
			return this.activeGroup === this.groupType && this.activeIndex === index
		}
	}
})
</script>

<style lang="less" scoped>
@import '../../less/variables';

.result-group {
	margin-bottom: 1.5rem;
	&:last-child {
		margin-bottom: 0;
	}
}

.group-header {
	font-size: 0.75rem;
	font-weight: 600;
	text-transform: uppercase;
	color: @grayMedium;
	margin-bottom: 0.5rem;
	padding: 0 0.5rem;
	letter-spacing: 0.025em;
}
.show-more-button {
	text-align: center;
	cursor: pointer;
	color: @grayMedium;
	font-size: 0.75rem;
	padding: 0.5em;
	&:hover {
		color: @grayDark;
	}
}
</style>
